import moment from 'moment'
import _ from 'lodash'
import {getHabilitations} from "../../utils/habilitations";

async function findData(context){

    const yesterdayMoment = moment().subtract(1, 'days')
    const lastWeekMoment = moment().subtract(7, 'days')

    const yesterdayISO = yesterdayMoment
        .format('DD-MM-YYYY')
    const todayISO = moment()
        .format('DD-MM-YYYY')
    const lastWeekISO = lastWeekMoment
        .format('DD-MM-YYYY')


    const dashboardDates = [lastWeekISO, yesterdayISO]

    const alertConfigurationCollection = global.app.S.AlertConfiguration.collection
    const alertConfigurationQuery = alertConfigurationCollection
        .find({
            code: "DBEcartCaisseEtAnnulationTicket"
        })
        .toArray()

    const [storeHabilitations, orgHabilitations] = await getHabilitations(context)
    const stores = storeHabilitations.map(hab => _.get(hab, 'store._id'))
    const organizations = orgHabilitations.map(hab => _.get(hab, 'organization._id'))

    const habQuery = stores.length || organizations.length
        ? {
            $or: [
                {store: {$in : stores}},
                {organizations: {$in: organizations}}
            ],
        }
        : {}

    const [alertConfigurations] = await Promise.all([alertConfigurationQuery])
    const alertConfiguration =  alertConfigurations[0]

    const dates = [lastWeekISO, todayISO].map(date => moment.utc(date.trim(), 'DD-MM-YYYY'))

    const organizationAlertsPromise = global.app.S.Alert.collection
        .aggregate([
            {
                $match: {
                    'date.gte': { $gte: dates[0].toDate() },
                    'date.lt': { $lte: dates[1].toDate() },
                    'alertConfiguration': alertConfiguration._id,
                    ...habQuery
                }
            }
        ])
        .toArray()

    const [organizationAlerts] = await Promise.all([organizationAlertsPromise])

    const totalByStore = organizationAlerts.reduce((acc, alert) => {
        if(!acc[alert['store']]) acc[alert['store']] = 1
        else acc[alert['store']]++
        return acc
    }, {})


    const formatedResult = Object.keys(totalByStore)
        .map(key => ({
            store: key,
            value: totalByStore[key]
        }))
        .sort((a, b) => b.value - a.value)


    const topTenResults = _.slice(formatedResult, 0, 10)

    return [{
        id: "tillDifferencesAndCancellations",
        subTitle: {
            text: `${dashboardDates[0]} au ${dashboardDates[1]}`,
            font: '11px',
            color: '#888383'
        },
        data: topTenResults
    }]
}

export const entity = {
    name: 'TillDifferencesAndCancellations',
    dashboard: true,
    fields: [
        "id",
        "subTitle",
        "data",
    ],
    find: function(context, callback) {
        this.prepareContext(context, 'L', (error, context) => {
            if (error) callback(error);
            else findData(context)
                .then(objects => callback(null, objects))
                .catch(error => callback(error))
        });
    }
}
